'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { IServicePreview } from 'app/interfaces/services';
import ServiceFeaturedCard from './ServiceFeaturedCard';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';

export default function ServiceFeaturedSlider({
  items
}: {
  items: IServicePreview[];
}) {
  return (
    <Swiper spaceBetween={-12}>
      {items.map((item, index) => {
        return (
          <SwiperSlide key={index} className="px-3">
            <ServiceFeaturedCard data={item} />
          </SwiperSlide>
        );
      })}
      <div className="flex gap-1 justify-end wrapper-main mt-3">
        <SwiperButtonPrev />
        <SwiperButtonNext />
      </div>
    </Swiper>
  );
}
